import axios from 'axios'

export default {
  getJobRequests ( params, callback ) {
    axios.get('/job-requests', { params })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(() => {});
  },
  getJobRequest ( jobRequestId, callback ) {
    axios.get('/job-requests/' + jobRequestId)
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(() => {});
  },
  create ( data, callback, fallback ) {
    axios.post( '/job-requests', data )
      .then(resp => {
        if(typeof(callback) != 'undefined')
          callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined')
          fallback(error);
      });
  },
  save ( jobRequestId, data, callback, fallback ) {
    axios.post( '/job-requests/' + jobRequestId, data )
      .then(resp => {
        if(typeof(callback) != 'undefined')
          callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  createJob ( jobRequestId, callback, fallback ) {
    axios.post( '/job-requests/' + jobRequestId + '/job', {} )
      .then(resp => {
        if(typeof(callback) != 'undefined')
          callback( resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  createQuote ( jobRequestId, callback, fallback ) {
    axios.post( '/job-requests/' + jobRequestId + '/quote', {} )
      .then(resp => {
        if(typeof(callback) != 'undefined')
          callback( resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  delete ( jobRequestId, callback, fallback ) {
    axios.delete( '/job-requests/' + jobRequestId )
      .then(resp => {
        if(typeof(callback) != 'undefined')
          callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  deleteMany ( jobRequestIds, callback, fallback ) {
    axios.post( '/job-requests/delete', { ids: jobRequestIds })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  deleteAttachment ( jobRequestId, attachmentId, callback, fallback ) {
    axios.delete( '/job-requests/' + jobRequestId + '/attachments/' + attachmentId )
      .then(resp => {
        if ( typeof callback == 'function' ) {
          callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
        }
      })
      .catch(() => {
        if ( typeof fallback == 'function' ) {
          fallback();
        }
      })
  }
}
